/**
 * Logical types
 */
import { NestedSchema, RootSchema } from '../../union';
import { ISchemaAnyOf, ISchemaLogicalContent, ISchemaOneOf } from './logical.types';

export * from './logical.types';

/**  Types  */
interface ISchemaOneOfInput<Types extends ISchemaLogicalContent> {
    description: string;
    schemata: Array<Types>;
    $id?: string;
    title?: string;
}

interface ISchemaAnyOfInput<Types extends ISchemaLogicalContent> {
    description: string;
    schemata: Array<Types>;
    $id?: string;
    title?: string;
}

/**
 * oneOf[]
 */
export function oneOf<Types extends ISchemaLogicalContent>(
    input: RootSchema<ISchemaOneOfInput<Types>>
): RootSchema<ISchemaOneOf<Types>>;
export function oneOf<Types extends ISchemaLogicalContent>(
    input: NestedSchema<ISchemaOneOfInput<Types>>
): NestedSchema<ISchemaOneOf<Types>>;
export function oneOf<Types extends ISchemaLogicalContent>({
    schemata,
    ...input
}: ISchemaOneOfInput<Types>): ISchemaOneOf<Types> {
    return {
        ...input,
        oneOf: schemata,
    };
}

/**
 * anyOf[]
 */
export function anyOf<Types extends ISchemaLogicalContent>(
    input: RootSchema<ISchemaAnyOfInput<Types>>
): RootSchema<ISchemaAnyOf<Types>>;
export function anyOf<Types extends ISchemaLogicalContent>(
    input: NestedSchema<ISchemaAnyOfInput<Types>>
): NestedSchema<ISchemaAnyOf<Types>>;
export function anyOf<Types extends ISchemaLogicalContent>({
    schemata,
    ...input
}: ISchemaAnyOfInput<Types>): ISchemaAnyOf<Types> {
    return {
        ...input,
        anyOf: schemata,
    };
}
